import React, { useCallback, useMemo, useEffect } from 'react'
import { Card } from 'react-bootstrap'
import ReactTableBootstrap from 'react-table-bootstrap'
import TableActionItems from '../../../components/table-action-items/TableActionItems'
import { doRequestPost } from '../../../api'
import { toast } from 'react-toastify'
import { promiseCatch, doToast, rowEnabledText, getActions, addActionOnRow } from '../../../utils'
import { useGet } from '../../../hooks/process-data'
import { ProductForm } from '../product-form/ProductForm'
import { useSelector } from 'react-redux'
import { apiResource } from '../../../utils'

export const ProductView = () => {
  const { rows, isProcessing, setReload, error, setError } = useGet({
    url: '/product'
  })

  const { permissions } = useSelector(store => store.session)
  const actions = getActions({ permissions, module: 'productos' })

  const rowItem = useCallback(({
    row = {},
    type = 'update'
  }) => {
    const rowId = row.id_product

    return <TableActionItems
      data={row}
      type={type}
      rowId={rowId}
      formRender={({ modalHide }) => {
        return <ProductForm rowId={rowId} setReload={() => {
          setReload(true)
          modalHide()
        }} />
      }}
      doDelete={async ({ hideAlert, setProcessingAlert }) => {
        try {
          setProcessingAlert(true)
          const deleteRecord = await doRequestPost({
            url: '/product/delete',
            data: {
              p_id_product: rowId
            }
          })

          doToast({
            ...deleteRecord,
            toast
          })
          hideAlert()
          setReload(true)
        } catch (err) {
          promiseCatch({
            toast
          })
          setProcessingAlert(false)
        }
      }}
      showCreate={actions?.create}
      showUpdate={actions?.update}
      showDelete={actions?.delete}
    />
  }, [setReload, actions])

  const dtRows = useMemo(() => {
    const headItem = addActionOnRow({
      head: [
        { name: 'name_product', text: 'Nombre', align: 'center' },
        { name: 'type_product', text: 'Tipo', align: 'center', render: r => r.type_product?.name_type_product || '-' },
        { name: 'image_product', text: 'Imagen', align: 'center', render: row => {
          if (!row.image_product) return '-'
          return (
            <a href={apiResource({ url: row.image_product })} target="_blank" rel="noreferrer">
              <img src={apiResource({ url: row.image_product })} alt="" style={{ maxWidth: 50, height: 'auto' }} className="rounded" />
            </a>
          )
        } },
        { name: 'enabled_product', text: 'Estado', align: 'center', render: row => rowEnabledText({ enabled: row.enabled_product }) },
        { name: 'skus_count', text: 'Variantes', align: 'center', render: row => (row.skus && row.skus.length) || 0 },
      ],
      rowItem
    })

    return <ReactTableBootstrap
      head={[headItem]}
      rows={rows}
      isProcessing={isProcessing}
    />
  }, [rows, isProcessing, rowItem])

  useEffect(() => {
    if (error) {
      promiseCatch({
        toast
      })
      setError(false)
    }
  }, [error, setError])

  return (
    <div className='row'>
      <div className="col-xl-2 col-lg-1"></div>
      <div className="col-xl-8 col-lg-10">
        <Card>
          <Card.Body>
            {rowItem({ type: 'create' })}
            {dtRows}
          </Card.Body>
        </Card>
      </div>
    </div>
  )
}
